module.exports = __webpack_public_path__ + "static/media/C0.2f780a4e.svg";